// extracted by mini-css-extract-plugin
export default {"price":"_X-z","onSale":"aY-z","msrpLabelPrice":"bY-z","originalPrice":"cY-z","msrpLabel":"dY-z","percentOff":"eY-z"};